export const ENTER = 13;
export const SPACE = 32;
export const TAB = 9;
export const ESC_KEY = 27;

export const ENTER_KEY_NAME = 'Enter';
export const ESC_KEY_NAME = 'Escape';
export const SPACE_KEY_NAME = ' ';
export const TAB_KEY_NAME = 'Tab';
